function updateSortByPopoverWidth() {
  const popover = document.getElementById("sort-by-popover");
  if (popover) {
    const width = popover.offsetWidth;
    document.documentElement.style.setProperty(
      "--sort-by-popover-width",
      `${width}px`
    );
  }
}

// DOMの読み込みが完了したら実行
document.addEventListener("DOMContentLoaded", updateSortByPopoverWidth);

// ウィンドウのリサイズ時に実行（パフォーマンスのためにデバウンス処理を追加）
let resizeTimer;
window.addEventListener("resize", () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(updateSortByPopoverWidth, 250);
});

// ポップオーバーが表示されるときに実行
// 注: これはポップオーバーの表示方法によって異なる場合があります
document.addEventListener("popover-shown", (event) => {
  if (event.target.id === "sort-by-popover") {
    updateSortByPopoverWidth();
  }
});

// 追加：MutationObserverを使用して変更を監視
const popover = document.getElementById("sort-by-popover");
if (popover) {
  const observer = new MutationObserver(updateSortByPopoverWidth);
  observer.observe(popover, {
    attributes: true,
    childList: true,
    subtree: true,
  });
}

/*
  -- 2024.11.9 Product item slider on collection/search page --
*/
const productItemSliderInstanceList = {};

// 単一の Splide 要素をマウント or リフレッシュする
const mountSingleProductItemSlider = (splideElement) => {
  const sliderId = splideElement.getAttribute('data-product-item-slider');

  // 既にマウント済みなら表示サイズだけ再計算する
  if (productItemSliderInstanceList[sliderId]) {
    productItemSliderInstanceList[sliderId].refresh();
    return;
  }

  // hidden な祖先要素配下にある場合はマウントしない
  // (display:none 下では Splide の寸法計算が0になり、後でタブを開いた時に壊れて見える)
  if (splideElement.closest('[hidden]')) {
    return;
  }

  const splide = new Splide(splideElement, {
    type: 'loop',
    perPage: 1,
    autoplay: false,
    arrows: true,
    pagination: false,
    direction: 'ltr',
  });

  splide.mount();
  productItemSliderInstanceList[sliderId] = splide;
};

const mountProductItemSlider = () => {
  document.querySelectorAll("[data-product-item-slider]").forEach(mountSingleProductItemSlider);
};

// タブ切り替えで product-list の hidden が外れた瞬間にスライダーをマウントする
// (tabs-nav の transitionContent は 250ms のフェード後に hidden を切り替えるため、
//  click イベント直後の refresh では「display:none 中に寸法計算してしまう」問題が起きる)
const observeProductListVisibility = () => {
  document.querySelectorAll('product-list').forEach((productList) => {
    if (productList.dataset.sliderObserverInitialized === 'true') return;
    productList.dataset.sliderObserverInitialized = 'true';

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'hidden' && !mutation.target.hidden) {
          mutation.target
            .querySelectorAll('[data-product-item-slider]')
            .forEach(mountSingleProductItemSlider);
        }
      });
    });
    observer.observe(productList, { attributes: true, attributeFilter: ['hidden'] });
  });
};

const productItemVariantPicker = () => {
  const productItemVariantPickerList = document.querySelectorAll("[data-variant-picker-product]");

  productItemVariantPickerList.forEach((variantPickerElement) => {
    // 既に初期化済みならスキップ（イベントリスナーの重複登録を防ぐ）
    if (variantPickerElement.dataset.variantPickerInitialized === 'true') return;
    variantPickerElement.dataset.variantPickerInitialized = 'true';

    const variantPickerItemList = variantPickerElement.querySelectorAll('[type="radio"]');
    variantPickerItemList.forEach((variantPickerItem) => {
      variantPickerItem.addEventListener('change', (event) => {
        // Change form action
        const variantId = event.target.value,
          variantAvailable = event.target.dataset.available,
          formElem = document.getElementById(event.target.dataset.form),
          variantFeaturedMedia = event.target.dataset.variantFeaturedMedia;

        if(variantAvailable !== "true"){
          formElem.querySelector('[type="submit"]').setAttribute('hidden', 'true');
        }else{
          formElem.querySelector('[type="submit"]').removeAttribute('hidden');
        }
        formElem.querySelector('[name="id"]').value = variantId;
        
        // Select variant slide item
        if(variantFeaturedMedia){
          const variantSlideItem = formElem.closest("product-item").querySelector(`[data-product-item-slider-item="${variantFeaturedMedia}"]`);
          if(variantSlideItem){
            const variantSlideItemIndex = parseInt(variantSlideItem.dataset.splideSlide);
            const variantSliderId = formElem.closest("product-item").querySelector(".splide[data-product-item-slider]").getAttribute('data-product-item-slider');
            productItemSliderInstanceList[variantSliderId].go(variantSlideItemIndex);
          }
        }
      });
    });
  });
}

// 初期表示時、絞り込みフィルター変更(ソート変更、ページネーション)時にスライダーをマウント
document.addEventListener("DOMContentLoaded", function(event) {
  mountProductItemSlider();
  productItemVariantPicker();
  observeProductListVisibility();
  if (typeof window.initProductWishlist === 'function') {
    window.initProductWishlist();
  }
});
document.addEventListener("facet:rerender", function(event) {
  mountProductItemSlider();
  productItemVariantPicker();
  observeProductListVisibility();
  if (typeof window.initProductWishlist === 'function') {
    window.initProductWishlist();
  }
});